import { z } from 'zod';
import { isoDateString } from '../_shared/dates.js';
const promotionalCodeCompanySchema = z.object({
    id: z.string(),
    name: z.string(),
    iataCode: z.string(),
});
export const createPromotionalCodeSchema = z.object({
    code: z.string().min(5).max(10),
    companies: z.array(promotionalCodeCompanySchema),
    destinationIataCodes: z.array(z.string()),
    discount: z.number().positive(),
    expiresAt: isoDateString(),
    maxUsage: z.number(),
    originIataCodes: z.array(z.string()),
    validFrom: isoDateString().nullish(),
    validTo: isoDateString().nullish(),
});
